import Reflux from 'reflux';
import SearchActions from '../actions/SearchActions';
import axios from 'axios';

export default class SearchStore extends Reflux.Store {
    constructor () {
        super();
        this.state = {
            searchResult: {
                usertopics: [],
                globaltopics: [],
                users: [],
                followingtopics: []
            },
            searching: false,
            suggestedUsers: [],
            apiUrl: process.env.REACT_APP_API_URL + '/api'
        };
        this.listenables = SearchActions;
    }

    onSearch (query) {
        this.setState({searching: true});
        axios.get(this.state.apiUrl + '/search/' + query)
          .then((resp) => {
              this.setState({searchResult: resp.data, searching: false});
          })
          .catch((error) => {
              this.setState({searching: false});
              console.error(error);
          });
    }

    onGetUserSuggestions () {
        axios.get(this.state.apiUrl + '/users?sort=-followers&&limit=4')
          .then((resp) => {
              this.setState({suggestedUsers: resp.data});
          })
          .catch((error) => {
              console.error(error);
          });
    }

    onCleanSearch () {
        this.setState({
            searchResult: {
                usertopics: [],
                globaltopics: [],
                users: [],
                followingtopics: []
            }
        });
    }

    onFilterResultsFollowing () {
        this.setState({
            searchResult: {
                usertopics: this.state.searchResult.followingtopics,
                globaltopics: [],
                users: [],
                followingtopics: []
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/stores/SearchStore.js